import { ReactComponent as AUS } from "../../../assets/icons/Flags/AUS.svg";
import { ReactComponent as USA } from "../../../assets/icons/Flags/USA.svg";
import { ReactComponent as GBP } from "../../../assets/icons/Flags/GBP.svg";
import { ReactComponent as JPN } from "../../../assets/icons/Flags/JPN.svg";
import { ReactComponent as GBR } from "../../../assets/icons/Flags/GBR.svg";
import { ReactComponent as HKG } from "../../../assets/icons/Flags/HKG.svg";
import { ReactComponent as CHE } from "../../../assets/icons/Flags/CHE.svg";
import { ReactComponent as FRA } from "../../../assets/icons/Flags/FRA.svg";
import { ReactComponent as DEU } from "../../../assets/icons/Flags/DEU.svg";
import { ReactComponent as SGP } from "../../../assets/icons/Flags/SGP.svg";
import { ReactComponent as CAN } from "../../../assets/icons/Flags/CAN.svg";

const ccList = [
  { cc: "AUS", flag: <AUS /> },
  { cc: "USA", flag: <USA /> },
  { cc: "GBP", flag: <GBP /> },
  { cc: "GBR", flag: <GBR /> },
  { cc: "JPN", flag: <JPN /> },
  { cc: "HKG", flag: <HKG /> },
  { cc: "CHE", flag: <CHE /> },
  { cc: "FRA", flag: <FRA /> },
  { cc: "DEU", flag: <DEU /> },
  { cc: "SGP", flag: <SGP /> },
  { cc: "CAN", flag: <CAN /> },
];

export const getFlagSvg = (cc: string) => {
  try {
    const index = ccList.findIndex((item) => item.cc === cc);
    return ccList[index].flag;
  } catch (err) { }
};
